import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
import { CatalogModifierToggleOverrideType } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export const ModifierToggleOverrideType = NumericEnum.createFromObject(CatalogModifierToggleOverrideType);